import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=a2e8ee70&scoped=true&"
import script from "./MessageCard.vue?vue&type=script&lang=js&"
export * from "./MessageCard.vue?vue&type=script&lang=js&"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=a2e8ee70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e8ee70",
  null
  
)

export default component.exports